import { render, staticRenderFns } from "./DocumentsFolder.vue?vue&type=template&id=12c0bdc8&"
import script from "./DocumentsFolder.vue?vue&type=script&lang=ts&"
export * from "./DocumentsFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports